module.exports = __webpack_public_path__ + "img/sun-illustration-01.4d1e3eff.png";